theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerWrapper = document.querySelector('.header');
    const stickyHeader = document.querySelector('.header__sticky');

    if (!headerWrapper || !stickyHeader) return;

    let headerHeight = headerWrapper.offsetHeight;
    let lastScrollY = window.scrollY;

    // Recalculate height on resize
    window.addEventListener('resize', () => {
      headerHeight = headerWrapper.offsetHeight;
    });

    window.addEventListener('scroll', () => {
      lastScrollY = window.scrollY;

      if (lastScrollY > headerHeight) {
        stickyHeader.classList.add('sticky');
      } else {
        stickyHeader.classList.remove('sticky');
      }
    });
  }
  return ScrollSticky;
})();
